module.exports = __webpack_public_path__ + "img/20190530160417995.0151448b.png";